"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKVerticalBarChart = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var helpers_1 = require("../common/helpers");
var VerticalBar_1 = require("./VerticalBar");
var GKBarChartContext_1 = require("../GKBarChartContext");
var GKVerticalBarChart = function (props) {
    // State for the tallest xLabel, used in calculations below.
    var _a = React.useState(0), yLabelMaxHeight = _a[0], setYLabelMaxHeight = _a[1];
    var _b = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-vertical-bar-chart",
    }), data = _b.data, height = _b.height, mappedProps = __rest(_b, ["data", "height"]);
    var _c = (0, helpers_1.getBounds)(data), min = _c.min, range = _c.range;
    var pixelAdjustment = Math.max((min / range) * height * -1, 0);
    // Receives yLabel heights and updates state if it's the tallest
    var updateYLabelHeight = function (height) {
        if (height > yLabelMaxHeight) {
            setYLabelMaxHeight(height);
        }
    };
    var xAxisLabels = data.map(function (d) { return (React.createElement("p", { key: d.xLabel, "data-qa": mappedProps["data-qa"] + "--xlabel", className: "w-100 mt-2 px-2 text-center" }, d.xLabel)); });
    var barQA = mappedProps["data-qa"] + "--datum";
    var bars = React.useMemo(function () {
        return data.map(function (d, i) { return (React.createElement(VerticalBar_1.VerticalBar, { key: i, d: d, range: range, qa: barQA })); });
    }, [barQA, range, data]);
    return (React.createElement("div", __assign({}, mappedProps),
        React.createElement("div", { className: "overflow-hidden", style: { paddingTop: yLabelMaxHeight } },
            React.createElement("div", { className: "d-flex align-items-end border-bottom border-dark", style: {
                    position: "relative",
                    bottom: pixelAdjustment + "px",
                    height: height,
                }, "data-qa": mappedProps["data-qa"] + "--bar-container" },
                React.createElement(GKBarChartContext_1.BarChartContext.Provider, { value: { updateYLabelSize: updateYLabelHeight } }, bars))),
        React.createElement("div", { className: "d-flex" }, xAxisLabels)));
};
exports.GKVerticalBarChart = GKVerticalBarChart;
exports.default = exports.GKVerticalBarChart;
